import { Injectable } from '@angular/core'

import { DataLayerService } from '../data-layer.service'
import { IFeatureTrack } from './feature-tracking.interfaces';


@Injectable()
export class FeatureTrackingService {

    constructor(
        private dataLayerService: DataLayerService) {
    }

    public track(featureName: string, featureVariant: any): void {

        let featureTrack = this.getFeatureTrack(featureName, featureVariant)
        this.dataLayerService.push(featureTrack)
    }

    private getFeatureTrack(featureName: string, featureVariant: any): IFeatureTrack {

        return <IFeatureTrack>{
            event: 'featureTest',
            eventCategory: 'featureTest',
            eventAction: featureName.toLowerCase(),
            eventLabel: featureVariant.toString().toLowerCase()
        }
    }

}
